import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import "./calender.css";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import StopIcon from "@mui/icons-material/Stop";
import UpdateComponent from "./UpdateModal";
import axios from "../../config/axios";
import { handleAxiosResponseError } from "utils/handleResponseError";
import styles from "./pick.module.css";
import { Chip, CircularProgress } from "@mui/material";
import { DateFormate } from "utils/DateFormate";
import { DateConverter, DateSet } from "utils/DateFormate";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteEvents } from "api/all.api";
import ScrollBar from "components/scrollbar";

const style = {
  event: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    height: "100%",
    minHeight: 700,
    maxHeight: 700,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  },
  update: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    maxHeight: "90vh",
    overflowY: "auto",
    p: 4,
  },
};

export default function EventModel({
  open,
  setOpen,
  event,
  nameEvents,
  users,
  setGoogleEvents,
  googleToken,
}) {
  const [editModal, setEditModal] = useState(false);
  const [propEvents, setPropEvents] = useState([]);
  const [names, setNames] = useState([]);
  const [owner, setOwner] = useState("");
  const [isAuthorized, setIsAuthorized] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const startDate = event?.start && DateConverter(event?.start);
  const endDate = event?.end && DateConverter(event?.end);
  const date =
    event?.date && DateConverter(DateSet(event?.date?.split("T")[0]));

  const queryClient = useQueryClient();
  const deleteMutation = useMutation({
    mutationFn: deleteEvents,
    onSuccess: (data, variables) => {
      if (data?.error) throw data.error;
      else {
        queryClient.setQueryData(
          ["events", googleToken ? googleToken : "logged_out"],
          (oldEvents) => oldEvents.filter((item) => item._id !== event?.id)
        );

        if (variables?.googleEventId) {
          queryClient.setQueryData(
            ["events", googleToken ? googleToken : "logged_out"],
            (oldEvents) =>
              oldEvents.filter(
                (item) => item?.googleEventId !== variables?.googleEventId
              )
          );
          setGoogleEvents((prev) =>
            prev.filter((gEvent) => gEvent.id !== variables.googleEventId)
          );
        }

        toast.success(data.message);
        setOpen(false);
      }
    },
    onError: (err) => {
      toast.error(err);
      console.log("Error : ", err);
    },
  });

  useEffect(() => {
    if (event?.id) {
      setIsLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_SERVER_URL}/api/calendar/permission?eventId=${event?.id}`
        )
        .then(({ data }) => {
          setIsAuthorized(data.permission);
          if (!data.permission) setOwner(data?.owner);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          setIsAuthorized(false);
          console.log(handleAxiosResponseError(err));
        });
    }
  }, [event]);

  const handleClose = () => setOpen(false);
  const handleEdit = () => {
    setEditModal(true);
    setOpen(false);
  };

  useEffect(() => {
    setNames([]);
    if (nameEvents && users) {
      users.forEach((user) => {
        nameEvents.forEach((eve) => {
          if (eve?.eventId === event?.id && eve?.eventOff === user._id) {
            setNames((prev) => [...prev, user.firstName + " " + user.lastName]);
          }
        });
      });
    }

    return () => {
      setNames([]);
    };
  }, [nameEvents, users, event]);

  const handleEditClose = () => {
    setEditModal(false);
  };

  useEffect(() => {
    if (nameEvents?.length && nameEvents[0]?.eventId !== null)
      setPropEvents(
        nameEvents?.filter((eve) => {
          if (eve && eve.eventId === event.id) return true;
          else return false;
        })
      );

    return () => {
      setPropEvents([]);
    };
  }, [event, nameEvents]);

  const handleDelete = () => {
    deleteMutation.mutate({
      id: event?.id,
      googleEventId: event?.googleEvent?.length
        ? event.googleEvent
        : event?.googleEventId,
      token: googleToken,
    });
  };

  return (
    <div>
      <Modal
        open={editModal}
        onClose={handleEditClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style.update} className={styles.modal}>
          <UpdateComponent
            setOpen={setEditModal}
            event={event}
            propEvents={propEvents}
            users={users}
            setGoogleEvents={setGoogleEvents}
          />
        </Box>
      </Modal>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        id="modal"
      >
        {isLoading ? (
          <Box sx={style.event}>
            <div className="d-flex justify-content-center mt-5">
              <CircularProgress color="inherit" />
            </div>
          </Box>
        ) : (
          <Box sx={style.event}>
            <div className="d-flex justify-content-between">
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                className="font-weight-bold text-dark"
              >
                <StopIcon sx={{ color: event.color }} />
                {event.title}
              </Typography>
              <div className="mt-1 mr-3 d-inline-flex">
                {isAuthorized &&
                  (event?.id || event.googleEvent) &&
                  !event?.allowEdit && (
                    <>
                      <EditIcon
                        fontSize="small"
                        sx={{ marginRight: "15px", cursor: "pointer" }}
                        onClick={handleEdit}
                      />
                      <DeleteIcon
                        fontSize="small"
                        sx={{ marginRight: "15px", cursor: "pointer" }}
                        onClick={handleDelete}
                      />
                    </>
                  )}
                <ClearIcon
                  fontSize="small"
                  sx={{ cursor: "pointer" }}
                  onClick={handleClose}
                />
              </div>
            </div>
            <ScrollBar eventModal={true}>
              {endDate && (
                <>
                  <Typography
                    id="modal-modal-description"
                    sx={{
                      mt: 2,
                      fontWeight: "light",
                      color: "gray",
                      fontSize: "15px",
                    }}
                  >
                    Start Date : {DateFormate(startDate)}
                  </Typography>
                  <Typography
                    id="modal-modal-description"
                    sx={{
                      fontWeight: "light",
                      color: "gray",
                      fontSize: "15px",
                      mb: 1,
                    }}
                  >
                    Due Date : {DateFormate(endDate)}
                  </Typography>
                </>
              )}
              {!endDate && (
                <Typography
                  id="modal-modal-description"
                  sx={{
                    mt: 1,
                    fontWeight: "light",
                    color: "gray",
                    fontSize: "15px",
                  }}
                >
                  Date : {DateFormate(date)}
                </Typography>
              )}

              {owner ? (
                <Typography
                  id="modal-modal-description"
                  sx={{
                    mt: 1,
                    fontWeight: "light",
                    color: "gray",
                    fontSize: "15px",
                  }}
                >
                  Created by : {owner}
                </Typography>
              ) : (
                <></>
              )}
              {names.length ? (
                <div
                  id="transition-modal-description"
                  style={{
                    mt: 2,
                    fontWeight: "light",
                    color: "gray",
                    fontSize: "15px",
                  }}
                >
                  Users :{" "}
                  {names &&
                    names.map((name, index) => (
                      <Chip
                        key={index}
                        label={name}
                        size="small"
                        className="mt-1"
                      />
                    ))}
                </div>
              ) : (
                ""
              )}
              {event?.desc?.length ? (
                <Typography
                  id="modal-modal-description"
                  sx={{ mt: 2, fontSize: "16px" }}
                >
                  Description : {event?.desc}
                </Typography>
              ) : (
                ""
              )}
            </ScrollBar>
          </Box>
        )}
      </Modal>
    </div>
  );
}
